import dayjs from 'dayjs';

import { DriverDay } from '~hooks/useDriverDays/models';

type DriverDayCsvRow = {
  Date: string;
  Driver: string;
  'Truck Number': string;
  'Start Time': string;
  'End Time': string;
  'Total Hours': string;
  Approved: string;
  'Job Count': string;
  'Load Count': string;
  'Ticket Count': string;
};

export function transformDriverDaysToCSV(driverDays: DriverDay[]): DriverDayCsvRow[] {
  return driverDays.map((dd) => {
    const startTime = dd.adjustedStartedShiftAt ?? dd.startedShiftAt;
    const endTime = dd.adjustedEndedShiftAt ?? dd.endedShiftAt;
    const totalHours =
      dd.totalShiftMinutes !== null && dd.totalShiftMinutes !== undefined
        ? (dd.totalShiftMinutes / 60).toFixed(2)
        : '';

    return {
      Date: dd.driverDayDate ? dayjs(dd.driverDayDate).format('YYYY-MM-DD') : '',
      Driver: dd.driver?.fullName ?? '',
      'Truck Number': dd.equipmentExternalIds?.join(', ') ?? '',
      'Start Time': startTime ? dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') : '',
      'End Time': endTime ? dayjs(endTime).format('YYYY-MM-DD HH:mm:ss') : '',
      'Total Hours': totalHours,
      Approved: dd.approved ? 'Approved' : 'Not Approved',
      'Job Count': String(dd.jobCount ?? 0),
      'Load Count': String(dd.loadsCount ?? 0),
      'Ticket Count': String(dd.ticketsCount ?? 0),
    };
  });
}
